// Mock Data for Swipe System
// Sample data for testing and development

import { SwipeCard, UserProfile, CardTeaser, CardRevealed } from '../../types/swipe';
import { logger } from '../../utils/logger';

// Mock user profiles
const mockUsers: UserProfile[] = [
  {
    id: 'user-1',
    name: 'Sarah',
    age: 28,
    location: 'San Francisco, CA',
    photos: [
      'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop'
    ],
    bio: 'Adventure seeker and coffee enthusiast. Love hiking, photography, and trying new restaurants. Looking for someone to explore the city with!',
    interests: ['Hiking', 'Photography', 'Coffee', 'Travel', 'Yoga'],
    personality: ['Adventurous', 'Creative', 'Optimistic', 'Independent'],
    distance: 2.5,
    lastActive: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    verified: true
  },
  {
    id: 'user-2',
    name: 'Alex',
    age: 32,
    location: 'Oakland, CA',
    photos: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=600&fit=crop'
    ],
    bio: 'Software engineer by day, musician by night. Love building things and playing guitar. Always up for a good conversation over craft beer.',
    interests: ['Music', 'Technology', 'Craft Beer', 'Gaming', 'Cooking'],
    personality: ['Analytical', 'Creative', 'Humor', 'Loyal'],
    distance: 5.2,
    lastActive: new Date(Date.now() - 30 * 60 * 1000), // 30 minutes ago
    verified: false
  },
  {
    id: 'user-3',
    name: 'Emma',
    age: 26,
    location: 'Berkeley, CA',
    photos: [
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=600&fit=crop'
    ],
    bio: 'Art teacher and nature lover. Spend weekends hiking and painting landscapes. Looking for someone who appreciates art and the outdoors.',
    interests: ['Art', 'Hiking', 'Painting', 'Museums', 'Gardening'],
    personality: ['Artistic', 'Nature-loving', 'Patient', 'Thoughtful'],
    distance: 8.7,
    lastActive: new Date(Date.now() - 4 * 60 * 60 * 1000), // 4 hours ago
    verified: true
  },
  {
    id: 'user-4',
    name: 'Michael',
    age: 30,
    location: 'San Jose, CA',
    photos: [
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop'
    ],
    bio: 'Fitness enthusiast and foodie. Love working out and trying new restaurants. Always looking for the next adventure!',
    interests: ['Fitness', 'Food', 'Travel', 'Sports', 'Wine'],
    personality: ['Energetic', 'Social', 'Competitive', 'Passionate'],
    distance: 12.3,
    lastActive: new Date(Date.now() - 1 * 60 * 60 * 1000), // 1 hour ago
    verified: false
  },
  {
    id: 'user-5',
    name: 'Jessica',
    age: 29,
    location: 'Palo Alto, CA',
    photos: [
      'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop'
    ],
    bio: 'Marketing professional who loves to travel. Always planning the next trip and collecting experiences. Looking for someone to share adventures with.',
    interests: ['Travel', 'Photography', 'Dancing', 'Languages', 'Culture'],
    personality: ['Adventurous', 'Social', 'Curious', 'Optimistic'],
    distance: 15.8,
    lastActive: new Date(Date.now() - 6 * 60 * 60 * 1000), // 6 hours ago
    verified: true
  },
  {
    id: 'user-6',
    name: 'David',
    age: 35,
    location: 'San Francisco, CA',
    photos: [
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop'
    ],
    bio: 'Chef and food blogger. Love creating new dishes and sharing them with others. Always experimenting in the kitchen!',
    interests: ['Cooking', 'Food', 'Travel', 'Wine', 'Photography'],
    personality: ['Creative', 'Passionate', 'Generous', 'Humor'],
    distance: 3.1,
    lastActive: new Date(Date.now() - 3 * 60 * 60 * 1000), // 3 hours ago
    verified: false
  },
  {
    id: 'user-7',
    name: 'Rachel',
    age: 27,
    location: 'San Francisco, CA',
    photos: [
      'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop'
    ],
    bio: 'Yoga instructor and wellness coach. Love helping people find balance and inner peace. Always learning and growing.',
    interests: ['Yoga', 'Meditation', 'Wellness', 'Nature', 'Reading'],
    personality: ['Peaceful', 'Empathetic', 'Mindful', 'Supportive'],
    distance: 1.8,
    lastActive: new Date(Date.now() - 45 * 60 * 1000), // 45 minutes ago
    verified: true
  },
  {
    id: 'user-8',
    name: 'Chris',
    age: 31,
    location: 'San Francisco, CA',
    photos: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=600&fit=crop',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=600&fit=crop'
    ],
    bio: 'Entrepreneur and startup enthusiast. Love building companies and solving problems. Always looking for the next big idea!',
    interests: ['Entrepreneurship', 'Technology', 'Investing', 'Sports', 'Books'],
    personality: ['Ambitious', 'Innovative', 'Risk-taking', 'Leadership'],
    distance: 4.2,
    lastActive: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
    verified: false
  }
];

// Generate teaser data from user profile
const generateTeaser = (user: UserProfile): CardTeaser => {
  const hints = [
    `Loves ${user.interests[0]?.toLowerCase() || 'adventure'}`,
    `Passionate about ${user.interests[1]?.toLowerCase() || 'life'}`,
    `Enjoys ${user.interests[2]?.toLowerCase() || 'new experiences'}`,
    `Coffee enthusiast`,
    `Travel lover`,
    `Fitness focused`,
    `Art and culture`,
    `Foodie at heart`
  ];

  // Sample profile videos (40% of users have videos)
  const mockVideos = [
    'https://www.w3schools.com/html/mov_bbb.mp4',
    'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
  ];
  
  const hasVideo = Math.random() > 0.6; // 40% chance of video
  const videoUrl = hasVideo ? mockVideos[Math.floor(Math.random() * mockVideos.length)] : undefined;

  return {
    photo: user.photos[0],
    video: videoUrl,
    name: user.name,
    age: user.age,
    location: user.location,
    hint: hints[Math.floor(Math.random() * hints.length)],
    distance: user.distance || 0
  };
};

// Generate revealed data from user profile
const generateRevealed = (user: UserProfile): CardRevealed => {
  // Calculate compatibility score (mock)
  const compatibility = Math.floor(Math.random() * 40) + 60; // 60-100%

  return {
    bio: user.bio,
    interests: user.interests,
    compatibility,
    personality: user.personality,
    photos: user.photos,
    socialProof: {
      mutualFriends: Math.floor(Math.random() * 5),
      commonInterests: Math.floor(Math.random() * 3) + 1
    }
  };
};

// Generate swipe cards from user profiles
export const generateSwipeCards = (count: number = 10): SwipeCard[] => {
  const shuffledUsers = [...mockUsers].sort(() => Math.random() - 0.5);
  
  return shuffledUsers.slice(0, count).map((user, index) => ({
    id: `card-${user.id}`,
    user,
    teaser: generateTeaser(user),
    revealed: generateRevealed(user),
    isFlipped: false,
    isAnimating: false
  }));
};

// Mock API responses
export const mockSwipeAPI = {
  getCardDeck: async (userId: string, preferences: any): Promise<SwipeCard[]> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // For now, return all users without filtering to ensure cards are shown
    const cards = generateSwipeCards(8); // Generate 8 cards
    
    return cards;
  },

  recordSwipe: async (userId: string, cardId: string, action: string): Promise<void> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    logger.log(`Recorded swipe: ${action} on card ${cardId} by user ${userId}`);
  },

  getMatchResults: async (userId: string): Promise<any[]> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 800));
    
    // Mock match results
    return [
      {
        id: 'match-1',
        userId: 'user-1',
        matchedUserId: 'user-2',
        matchedAt: new Date(Date.now() - 2 * 60 * 60 * 1000),
        isActive: true,
        lastMessage: 'Hey! How was your day?',
        unreadCount: 2
      },
      {
        id: 'match-2',
        userId: 'user-1',
        matchedUserId: 'user-3',
        matchedAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
        isActive: true,
        lastMessage: 'Thanks for the great conversation!',
        unreadCount: 0
      }
    ];
  },

  updatePreferences: async (userId: string, preferences: any): Promise<void> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300));
    
    logger.log(`Updated preferences for user ${userId}:`, preferences);
  },

  undoLastSwipe: async (userId: string): Promise<boolean> => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 400));
    
    // Mock undo success (90% success rate)
    return Math.random() > 0.1;
  }
};

// Default user preferences
export const defaultUserPreferences = {
  ageRange: [22, 40] as [number, number],
  maxDistance: 25,
  interests: ['Travel', 'Food', 'Music', 'Art', 'Fitness'],
  personalityTypes: ['Adventurous', 'Creative', 'Social'],
  verifiedOnly: false,
  photosOnly: true
};

// Mock user data
export const mockCurrentUser = {
  id: 'current-user',
  name: 'You',
  age: 28,
  location: 'San Francisco, CA',
  photos: ['https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop'],
  bio: 'Looking for meaningful connections and great conversations.',
  interests: ['Travel', 'Food', 'Music', 'Art'],
  personality: ['Adventurous', 'Creative', 'Social'],
  verified: true
};
